import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';
import { ButtonActionType } from '@website-builder/widgets/button/model/button-action-type.enum';

export class ButtonElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  content = 'Button';
  link = new TbLink();
  icon = '';
  iconAlignment = '';
  actionType = ButtonActionType.LINK;
  style = new GlobalButtonStyle();

  static normalizeInPlace(element: ButtonElement): ButtonElement {
    const pureElement = new ButtonElement();

    element.content = element.content ?? pureElement.content;
    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);
    element.actionType = element.actionType ?? pureElement.actionType;
    element.icon = element.icon ?? pureElement.icon;
    element.iconAlignment = element.iconAlignment ?? pureElement.iconAlignment;

    element.style = GlobalButtonStyle.normalize(element.style);

    return element;
  }
}
